import React from 'react';
import {
    RadioButton,
    Banner,
    Stack,
    Card,
    Button
} from '@shopify/polaris';
import ProductConditionsComponent from './ProductConditionsComponent';

class ProductConditionsPaneComponent extends React.Component {

    nextProductFilterId = 0;

    constructor(props) {
        super(props)

        this.state = {
            productFilters: this.props.productFilters,
            productFiltersLogicalOperator: this.props.productFiltersLogicalOperator,
            expanded: this.props.expanded,
        }

        this.checkSmartcollections();
        this.checkTagOperations();
        this.nextProductFilterId = this.getLargestId(this.state.productFilters);
    }

    getLargestId = (items) => {
        if (items.length === 0) {
            return 0;
        }

        const max = items.reduce(function (max, item) {
            return Math.max(max, item.id);
        }, 0);
        return max + 1;
    }

    checkSmartcollections = () => {
        this.state.productFilters.forEach((item) => {
            if (item.filterType === "productSmartCollection") {
                var collection = this.props.smartCollections.find(_ => _.id === item.productCollectionId);
                if (collection == null) {
                    item.productCollectionId = null;
                }
            }
        });
    }

    checkTagOperations = () => {
        this.state.productFilters.forEach((item) => {
            if (item.filterType === "productProcessedByOperation") {
                var operation = this.props.tagOperations.find(_ => _.id === item.tagOperationId);
                if (operation == null) {
                    item.tagOperationId = null;
                }
            }
        });
    }

    render() {

        let hasConditions = this.state.productFilters.length > 0;
        const hasErrors = this.state.productFilters.filter(_ => _.isValid === false).length > 0;
        const expanded = this.state.expanded;

        let main = (<div><Card.Section>
            <p>Use product conditions to specify which products will be considered when applying tag operations.</p>
        </Card.Section>
            <Card.Section>
                {hasConditions &&
                    <div>
                        <div className="logicalConditionContainer">
                            <p><span>Products must match: </span>
                                <RadioButton
                                    id="andLogicalConditionRadio"
                                    label="all conditions"
                                    checked={this.state.productFiltersLogicalOperator === 'And'}
                                    onChange={this.handleConditionChange}
                                />
                                <RadioButton
                                    id="anyLogicalConditionRadio"
                                    label="any condition"
                                    checked={this.state.productFiltersLogicalOperator === 'Or'}
                                    onChange={this.handleConditionChange}
                                />
                            </p>
                            <br></br>
                        </div>
                        <Stack distribution="fill" spacing="extraLoose">
                            <ProductConditionsComponent
                                errors={this.state.errorsProductFilters}
                                variants={this.props.variants}
                                smartCollections={this.props.smartCollections}
                                tagOperations={this.props.tagOperations}
                                selectedOptions={this.props.selectedOptions}
                                tags={this.props.tags}
                                filters={this.state.productFilters}
                                onFilterDelete={this.handleFilterDelete}
                                onValueChange={this.handleValueChange}
                                onOperatorChange={this.handleOperatorChange}
                                onFilterTypeChange={this.handleFilterTypeChange}
                                onFilterUpdated={this.handleFilterUpdated} />
                        </Stack>
                    </div>
                }
                {/* <Link url="">Let us know what you think</Link> */}
                {!hasConditions &&
                    <Banner>
                        <p>No conditions have been defined. All products will be considered for this operaiton.</p>
                    </Banner>
                }
                <br />
                <Button onClick={this.onAddFilter}>Add Condition</Button>

            </Card.Section></div>);

        if (!expanded) {
            main = (<br />);
        }

        let primaryFooterAction = { content: 'Apply Conditions', onAction: this.onApplyClick, disabled: hasErrors };

        if (this.props.autoUpdateFilters || !expanded) {
            primaryFooterAction = null;
        }

        let filterCard = (<Card
            title="PRODUCT CONDITIONS"
            footerActionAlignment="right"
            primaryFooterAction={primaryFooterAction}
            actions={[
                { content: 'Show/Hide', onAction: this.onToggleExpanded },

            ]}>
            {main}
        </Card>);

        return filterCard;
    }

    containsSpecialCharacters(str) {
        var regex = /[=[\]'\\,<>?]/g;
        return regex.test(str);
    }

    handleConditionChange = (newvalue, id) => {

        if (id === "andLogicalConditionRadio") {
            this.setState({ productFiltersLogicalOperator: "And" }, () => this.onFiltersUpdatedInternal());
        }
        else {
            this.setState({ productFiltersLogicalOperator: "Or" }, () => this.onFiltersUpdatedInternal());
        }
    }

    validateProductFilters(filters) {
        var errors = {};

        filters.forEach((item) => {
            // TODO: Move validation to filterItself?s
            item.isValid = true;

            if (item.filterType === "ProductNameFilter") {

                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Value for product name must be provided.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "ProductDescriptionFilter") {

                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Value for product description must be provided.";
                    item.isValid = false;

                }
            }

            if (item.filterType === "ProductTypeFilter") {

                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Value for product type must be provided.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "ProductVendorFilter") {

                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Value for product vendor must be provided.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productVariantQuantity") {
                if (item.variantTitle === "" || item.variantTitle === null) {
                    errors[item.id] = "Variant title must be selected.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productVariantTitle") {
                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Variant title value must be provided.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productTagsNew") {
                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Tag value must be provided.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "variantOption") {

                if (item.option === "" || item.option === null) {
                    errors[item.id] = "Variant option filter must have an option selected.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productCreatedAt") {

                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Created at filter must have a date selected.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productUpdatedAt") {

                if (item.value === "" || item.value === null) {
                    errors[item.id] = "Created at filter must have a date selected.";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productPrice") {

                if (item.variantCondition === "" || item.variantCondition === null) {
                    errors[item.id] = "Variant condition must be set";
                    item.isValid = false;
                }

                if (item.priceCondition === "" || item.priceCondition === null) {
                    errors[item.id] = "Price condition must be set";
                    item.isValid = false;
                }

                if (item.price === "" || item.price === null) {
                    errors[item.id] = "Price must be set";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productCompareAtPrice") {

                if (item.variantCondition === "" || item.variantCondition === null) {
                    errors[item.id] = "Variant condition must be set";
                    item.isValid = false;
                }

                if (item.priceCondition === "" || item.priceCondition === null) {
                    errors[item.id] = "Price condition must be set";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productPricePercentageOfCompareAtPrice") {

                if (item.variantCondition === "" || item.variantCondition === null) {
                    errors[item.id] = "Variant condition must be set";
                    item.isValid = false;
                }

                if (item.percentageCondition === "" || item.percentageCondition === null) {
                    errors[item.id] = "Percentage condition must be set";
                    item.isValid = false;
                }

                if (item.percentage === "" || item.percentage === null || isNaN(item.percentage)) {
                    errors[item.id] = "Percentage must be set";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productSmartCollection") {

                if (item.condition === "" || item.condition === null) {
                    errors[item.id] = "Condition must be set";
                    item.isValid = false;
                }

                if (item.productCollectionId === "" || item.productCollectionId === null) {
                    errors[item.id] = "Product collection must be specified";
                    item.isValid = false;
                }
            }

            if (item.filterType === "productProcessedByOperation") {

                if (item.condition === "" || item.condition === null) {
                    errors[item.id] = "Condition must be set";
                    item.isValid = false;
                }

                if (item.tagOperationId === "" || item.tagOperationId === null) {
                    errors[item.id] = "Tag operation must be specified";
                    item.isValid = false;
                }
            }

            if (item.filterType === "timeSinceProductCreation") {

                if (item.condition === "" || item.condition === null) {
                    errors[item.id] = "Condition must be set";
                    item.isValid = false;
                }

                if (item.timeOffsetUnit === "" || item.timeOffsetUnit === null) {
                    errors[item.id] = "Unit of time must be st";
                    item.isValid = false;
                }

                if (item.timeOffsetLength <= 0 || item.timeOffsetLength === null) {
                    errors[item.id] = "Time length must be larger than 0";
                    item.isValid = false;
                }
            }

        });

        this.setState({
            errorsProductFilters: errors
        });
    }

    onApplyClick = () => {
        this.props.onFiltersUpdated(this.state.productFilters, this.state.productFiltersLogicalOperator);
    }

    onAddFilter = () => {

        let newConditions = [...this.state.productFilters,
        {
            "filterType": "ProductNameFilter",
            "field": "Name",
            "operator": "EqualTo",


            "value": "",
            "id": this.nextProductFilterId++
        }
        ];

        this.validateProductFilters(newConditions);

        this.setState({
            productFilters: newConditions
        }, () => this.onFiltersUpdatedInternal());
    }

    onToggleExpanded = () => {

        this.setState({
            expanded: !this.state.expanded
        });
    }

    getFilterById = (id) => {
        var matching = this.state.productFilters.filter((item) => item.id === id);

        if (matching.length > 0) {
            return matching[0];
        }

        return null;
    }

    handleFilterUpdated = (updatedFilter) => {
        let filter = this.getFilterById(updatedFilter.id);
        if (filter == null) {
            return;
        }

        if (filter.filterType !== updatedFilter.filterType) {
            this.initNewFilter(updatedFilter);
        }

        // TODO: Remove when filterUpdated is used everywhere
        let index = this.state.productFilters.findIndex(item => item.id === filter.id);
        var allFilters = this.state.productFilters;
        allFilters[index] = updatedFilter;

        this.validateProductFilters(allFilters);

        this.setState({
            productFilters: allFilters
        }, () => this.onFiltersUpdatedInternal());
    }

    handleOperatorChange = (item, newValue) => {
        item.operator = newValue;

        this.validateProductFilters(this.state.productFilters);

        // TODO: fix this hack
        this.setState({
            productFilters: this.state.productFilters
        }, () => this.onFiltersUpdatedInternal());
    }

    handleFilterTypeChange = (item, newValue) => {
        item.filterType = newValue;
        this.initNewFilter(item);

        this.validateProductFilters(this.state.productFilters);

        // TODO: fix this hack
        this.setState({
            productFilters: this.state.productFilters
        }, () => this.onFiltersUpdatedInternal());
    }

    onFiltersUpdatedInternal = () => {
        if (!this.props.autoUpdateFilters) {
            return;
        }

        this.props.onFiltersUpdated(this.state.productFilters, this.state.productFiltersLogicalOperator);
    }

    handleFilterDelete = (index) => {
        var newFilters = [
            ...this.state.productFilters.slice(0, index),
            ...this.state.productFilters.slice(index + 1)
        ];

        this.setState({
            productFilters: newFilters
        }, () => this.onFiltersUpdatedInternal());

        this.validateProductFilters(newFilters);
    }

    initNewFilter = (filter) => {

        filter.operator = "EqualTo";

        if (filter.filterType === "variantOption") {
            filter.operator = "IsAvailable";
            filter.option = null;
        }

        if (filter.filterType === "productTagsNew") {
            filter.operator = "EqualTo";
            filter.value = this.props.tags.length > 0 ? this.props.tags[0] : null;
        }

        if (filter.filterType === "productInventoryQuantity") {
            filter.quantityCondition = "GreaterThan";
            filter.variantCondition = "AnyVariant";
            filter.quantity = 0;
        }

        if (filter.filterType === "productStatus") {
            filter.condition = "EqualTo";
            filter.status = "Active";
        }

        if (filter.filterType === "productVariantQuantity") {
            filter.quantityCondition = "GreaterThan";
            filter.variantTitle = "";
            filter.quantity = 0;
        }

        if (filter.filterType === "productVariantTitle") {
            filter.operator = "EqualTo";
            filter.value = "";
        }

        if (filter.filterType === "productPrice") {
            filter.priceCondition = "GreaterThan";
            filter.variantCondition = "AnyVariant";
            filter.price = 0.0;
        }

        if (filter.filterType === "productCompareAtPrice") {
            filter.priceCondition = "IsSet";
            filter.variantCondition = "AnyVariant";
            filter.price = 0.0;
        }

        if (filter.filterType === "productPricePercentageOfCompareAtPrice") {
            filter.percentageCondition = "EqualTo";
            filter.percentage = 50.0;
            filter.variantCondition = "AnyVariant";
        }

        if (filter.filterType === "productCreatedAt") {
            filter.operator = "GreaterThan";
            filter.value = new Date().toISOString().substr(0, 10);
        }

        if (filter.filterType === "productUpdatedAt") {
            filter.operator = "GreaterThan";
            filter.value = new Date().toISOString().substr(0, 10);
        }

        if (filter.filterType === "productSmartCollection") {
            filter.operator = null;
            filter.condition = "BelongsTo";
            filter.productCollectionId = null;
        }

        if (filter.filterType === "productProcessedByOperation") {
            filter.operator = null;
            filter.condition = "Processed";
            filter.tagOperationId = null;
        }

        if (filter.filterType === "timeSinceProductCreation") {
            filter.condition = "AtLeast";
            filter.timeOffsetUnit = "Days";
            filter.timeOffsetLength = 1;
        }
    }

    handleValueChange = (item, newValue) => {
        item.value = newValue;

        this.validateProductFilters(this.state.productFilters);

        // TODO: fix this hack
        this.setState({
            productFilters: this.state.productFilters
        });
    }

    componentDidMount() {
        this.validateProductFilters(this.state.productFilters);
    }
}

ProductConditionsPaneComponent.defaultProps = {
    onFiltersUpdated: () => { },
    productFiltersLogicalOperator: "And",
    productFilters: [],
    autoUpdateFilters: false,
    updateButtonText: "Apply",
    tags: [],
    variants: [],
    smartCollections: [],
    selectedOptions: [],
    expanded: true
}

export default ProductConditionsPaneComponent;